import { useQuery } from 'react-query'
import { getCreditPolicies } from 'services/api'

export const useCreditPolicyGetAll = () => {
  return useQuery(['creditPolicyGetAll'], getCreditPolicies, {})
}
